const state = {
  copyright: {
    text: ''
  },
  gdpr: {
    wysiwyg: ''
  },
  menu: []
}

const getters = {
  getCopyright: state => state.copyright,
  getGdpr: state => state.gdpr,
  getMenu: state => state.menu
}

const mutations = {
  UPDATE_COPYRIGHT: (state, object) => {
    state.copyright = { ...object }
  },
  UPDATE_GDPR: (state, object) => {
    state.gdpr = { ...object }
  },
  UPDATE_MENU: (state, array) => {
    state.menu = [ ...array ]
  }
}

const actions = {
  updateCopyright: (store, data) => {
    store.commit('UPDATE_COPYRIGHT', data)
  },
  updateGdpr: (store, data) => {
    store.commit('UPDATE_GDPR', data)
  },
  updateMenu: (store, items) => {
    store.commit('UPDATE_MENU', items)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
